import React from "react";

const Footer = () => {
  return (
    <>
      <section className="footer">
        <div className="ftt">
          <h1>WE'RE HERE FOR YOU</h1>

          <h2>One quick call and you look wonderful!</h2>

          <div className="number">+91 8977013338</div>
        </div>


      </section >
      <div className="main">
        <div className="detail">
          <h1>heybabe_addcolourstoyournails</h1>
          <p>Follow us on Social Media</p>
          <div className="share">
            <a href="https://www.facebook.com/profile.php?id=61552047000243&mibextid=9R9pXO" target="_blank" rel="noopener noreferrer" class="fab fa-facebook-f">
            </a>
            <a href="https://instagram.com/heybabe_addcolourstoyournails?utm_source=qr" target="_blank" rel="noopener noreferrer" class="fab fa-instagram">
            </a>
          </div>
        </div>


        <div className="credit">
          created by heybabe_addcolourstoyournails@2023 | all rights reserved
        </div>
      </div>
    </>
  );
};

export default Footer;
